import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';
import { useI18n } from '../i18n';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useI18n();

  const handlePrivacyClick = () => {
    navigate('/privacy');
  };

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-contact">
          <span>{t('footer.contact')}</span>
          <a href="mailto:info@nicetone.ai" className="footer-email">
            info@nicetone.ai
          </a>
        </div>
        
        <div className="footer-divider">|</div>
        
        <div className="footer-copyright">
          © 2025 All Rights Reserved
        </div>
        
        <div className="footer-divider">|</div>
        
        <div className="footer-beta">
          {t('footer.beta')}
        </div>
        
        <div className="footer-divider">|</div>
        
        <button 
          onClick={handlePrivacyClick}
          className="footer-privacy-link"
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--ios-text-secondary)',
            fontSize: '12px',
            cursor: 'pointer',
            textDecoration: 'underline'
          }}
        >
          {t('footer.privacy')}
        </button>
      </div>
    </footer>
  );
};

export default Footer; 
